export default __webpack_public_path__ + "static/assets/8ff7a75079a853b78e3756a3b1bd5cea.png";